export default __webpack_public_path__ + "static/media/animal-47.b5150579.svg";